import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Subscription } from 'rxjs';

import { SnackbarService } from "../../../../shared/services/snackbar.service";
import { SessionStorageService } from "../../../../shared/services/session-storage.service";
import { FollowUpSmsService } from './follow-up-sms.service';

@Component({
    selector: 'follow-up-sms',
    styles: [require('./follow-up-sms.component.less')],
    template: require('./follow-up-sms.component.html'),
    providers: [FollowUpSmsService, SnackbarService],
    preserveWhitespaces: true
})
export class FollowUpSms {
    loading: boolean = false;
    editorContent: any;
    followupData: any;
    communicationData: any;
    public options: Object = {
        key: 'MA-16E-13oldxqvwtbvhlvoA5B-21qr==',
        charCounterCount: false,
        toolbarButtons: ['undo', 'redo'],
        toolbarButtonsXS: ['undo', 'redo'],
        toolbarButtonsSM: ['undo', 'redo'],
        toolbarButtonsMD: ['undo', 'redo'],
        imageUpload: false, // Disable image upload
        imagePaste: false, // Disable pasting images
        htmlEntities: false,
    };
    apiSubscriptions: Subscription[] = [];
    @Output() smsActionCompleted = new EventEmitter<any>();

    constructor(
        public dialogRef: MatDialogRef<any>,
        private _mdlSnackbarService: SnackbarService,
        private _sessionStorageService: SessionStorageService,
        private followupSmsService: FollowUpSmsService,
        @Inject('utilService') private utilService: any
    ) {

    }

    getTextData(data: any) {
        this.loading = true;
        this.communicationData = data;
        this.apiSubscriptions.push(this.followupSmsService.getFollowUpTextData(data)
            .subscribe((res: any) => this.getTextDataSuccessHandler(res),
                error => this.getTextDataErrorHandler))
    }

    decodeHTMLEntities(text: any) {
        const textarea = document.createElement("textarea");
        textarea.innerHTML = text;

        return textarea.value;
    }

    sendTextMsg() {
        let contentsFromEditor = this.editorContent;
        // Convert <p> tags to newlines
        contentsFromEditor = contentsFromEditor.replace(/<\/p>\s*<p>/g, "\n\n"); // Handles consecutive paragraphs
        contentsFromEditor = contentsFromEditor.replace(/<p>/g, ""); // Remove opening <p> tags
        contentsFromEditor = contentsFromEditor.replace(/<\/p>/g, ""); // Remove closing </p> tags

        // Convert <br> tags to newlines
        contentsFromEditor = contentsFromEditor.replace(/<br\s*\/?>/g, "\n");

        // decode HTML entities from editor
        contentsFromEditor =  this.decodeHTMLEntities(contentsFromEditor);

        if (contentsFromEditor.length > 1600) {
            this._mdlSnackbarService.showSnackbar('SMS_MAX_LENGTH_ERROR', 'error');
            return;
        }

        if (this.communicationData['fromSection'] != 'action_required_list') {
            this.followupData['text'] = contentsFromEditor;
            let chatData:any = { followUp_data: this.followupData, communication_data: this.communicationData};
            switch (this.communicationData['section']) {
                case 'parent_ortho_followup':
                    chatData['parent_relapse'] = true;
                    break;
                case 'patient_ortho_followup':
                    chatData['patient_relapse'] = true;
                    break;
                case 'patient_referral_followup':
                    chatData['from_referral'] = true;
                    break;
                case 'non_start_tracking_followup':
                    chatData['non_start_followup'] = true;
                    break;
                case 'virtual_consultation_followup':
                    chatData['vc_follow_up'] = true;
                    break;
                case 'follow-up':
                    chatData['follow_up'] = true;
                    break;
            }
            this.utilService.phoneNoChatDetails.next(chatData);
            this.dialogRef.close();
        } else {
            this.loading = true;
            const postData = {
                ids: [this.communicationData.id],
                method: 'text',
                message: contentsFromEditor,
            };
            this.apiSubscriptions.push(this.followupSmsService.postTextMsg(postData)
                .subscribe(res => {
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('TRIGGER_SENT', 'success');
                    this.smsActionCompleted.emit();
                    this.dialogRef.close();
                },
                    error => {
                        this.loading = false;
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    })
            );
        }
    }

    getTextDataSuccessHandler(res: any) {
        this.loading = false;
        this.editorContent = res['data']['text'];
        // Convert double newlines to paragraph tags
        this.editorContent = this.editorContent.replace(/\n\n/g, "</p><p>");
        // Convert single newlines to <br> (excluding ones already converted to paragraphs)
        this.editorContent = this.editorContent.replace(/\n/g, "<br>");
        // Wrap with <p> to ensure proper structure
        this.editorContent = "<p>" + this.editorContent + "</p>";

        this.followupData = res['data'];
    }

    getTextDataErrorHandler(error: any) {
        this.loading = false;
        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
    }

    ngOnInit() {
        this._sessionStorageService.readItem('textDetails').then((data: any) =>
            this.getTextData(data)
        );
    }

    ngOnDestroy() {
        this.apiSubscriptions.forEach((subscription) => {
            subscription?.unsubscribe();
        });
    }
}